import apiConfig from '../config/api';

const loginAV2APIURL = `${apiConfig.loginAV2API}`;

export const loginAV2API = (user) =>
  fetch(`${loginAV2APIURL}v1/sesion/crear`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      'Accept-Language': 'es',
    },
    body: JSON.stringify(user),
  });
